// NB: keep in sync with server side.
export enum LoginStatus {
	Success = 1,
	InvalidCredentials,
	EmailNotConfirmed,
	LockedOut
}